<template>
    <div class="crop-box" v-show="isCrop">
        <div class="crop-area-bg" v-show="!imgLoaded" >图片处理中...</div>
        <div id="crop_area" class="crop-area" :style="{opacity:opacity}" ></div>
        <span class="btn-rotate-left" @click="rotateLeft"></span>
        <div class="btn-box">
            <span class="btn-cancel" @click="cancelCrop">取消</span>
            <span class="btn-reset" @click="rotateReset">还原</span>
            <span class="btn-commit" @click="confirmCrop">完成</span>
        </div>
        <span id="crop_btn_hidden" style="opacity:0"></span>
    </div>
</template>

<script>
    import * as util from '@static/js/util.js';
	export default{
		data(){
			return{
			    //imgdata:'../../../../../static/images/test/1.jpg',
                imgLoaded : false,
                isCrop : false,
                rotate : 0,
                opacity : 0,
                fileName : '',
                fileSize : 0,
                credentials : null,
                fileUrlPre : null,
                uploadUrl : null
			}
		},
		methods:{
            getCredentials : function () {
                var _this = this;
                _this.$axios.post(_this.apiUrl + "/sts/get-credentials",_this.$qs.stringify({type : 20})).then(function (response) {
                    if (!response || !response.data.success) {
                        return _this.loading.hide();
                    }

                    _this.credentials = {
                        bucketName : response.data.bucket,
                        fileBucketName : response.data.filePath,
                        credentials : JSON.stringify(response.data.sts),
                        fileName: _this.fileName
                    };
                    _this.fileUrlPre = response.data.fileUrlPre;
                    _this.uploadUrl = response.data.uploadUrl;

                    // 设置参数
                    _this.uploader.setOption({
                        url : _this.uploadUrl,
                        multipart_params : _this.credentials
                    });

                    //alert("multipart_params：" + JSON.stringify(_this.credentials));
                    _this.uploader.start();
			    }).catch(function (error) {
			        _this.loading.hide();
                });
            },
            rotateLeft : function(){
                this.crop.rotate(-90);
            },
            rotateRight : function(){
                this.crop.rotate(10);
            },
            rotateReset : function(){
                this.crop.reset();
            },
            cancelCrop : function(){
                var _this = this;
                if(!_this.imgLoaded){
                    return;
                }
                _this.isCrop = false;
                _this.crop.destroy();
                _this.imgLoaded = false;
                _this.opacity = 0;
                if(_this.cancelCallback){
                    _this.cancelCallback();
                }
            },
            confirmCrop : function(){
                var _this = this;
                if(!_this.imgLoaded){
                    return;
                }
                if(_this.croping){
                    return weui.toast('正在处理，请稍等');
                }
                _this.croping = true;
                _this.loading = weui.loading('正在上传', {className: 'moka-loading'});
                var data = _this.crop.getCanvasData();
                var width,height;
                if(data.naturalWidth > 1000){
                    width = 1000;
                    height = data.naturalHeight * 1000 / data.naturalWidth;
                }
                var cas = _this.crop.getCroppedCanvas({
                    width : width,
                    height : height,
                    maxWidth: 4096,
                    maxHeight: 4096,
                });
                //cas.getContext("2d").drawImage(this, 0, 0, width, height);

                for(var index in _this.uploader.files){//清除所有文件
                    var upFile = _this.uploader.files[index];
                    _this.uploader.removeFile(upFile);
                }

                try {
                    cas.toBlob(function (bolb) {
                    var file = new File([bolb], _this.fileName, {type: 'image/jpeg'});
                    _this.croping = false;
                    _this.uploader.addFile(file);
                    }, "image/jpeg", 0.95)

                } catch (error) {
                    console.log(error);
                }


            },
            initUploader : function(options){
                var _this = this;

                var uploader = new plupload.Uploader({
                    runtimes : 'html5,flash',
                    browse_button : 'crop_btn_hidden', //选择文件按钮ID
                    max_file_size : '10mb',  //文件上传最大值
                    multipart : true,
                    chunks : true,//不分块上传
                    chunk_size : '10mb',//分块大小，小于这个大小的不分块
                    unique_names : true,  // 上传的文件名是否唯一,只有在未进行分块上传时文件名唯一才有效
                    url: _this.uploadUrl, //提交到后台的url地址
                    // flash_swf_url: '/js/lib/plupload/plupload.flash.swf',//plupload.flash.swf文件所在路径
                    flash_swf_url: '../../static/js/plupload/Moxie.swf',
                    silverlight_xap_url : '../../static/js/plupload/Moxie.xap', //silverlight文件，当需要使用silverlight方式进行上传时需要配置该参数
                    multi_selection : false,
                    init : {
                        FileUploaded : function(up, file, info) {//上传服务器方法，暂时未用到
                            up.disableBrowse(false);
                            var result = JSON.parse(info.response);
                            _this.loading.hide();
                            if(!result  || !result.success || !result.saveName){
                                return weui.alert('上传失败');
                            }

                            weui.toast('文件上传成功', {duration: 1000});

                            var attachFileName = file.name;    //源文件的名字
                            var saveName = _this.fileUrlPre.concat("/", result.saveName);
                            var fileSize = file.size;
                            if(_this.croppedCallback){
                                //zmf ？？？
                                //_this.croppedCallback('../../../../../static/images/test/1.jpg', '../../../../../static/images/test/1.jpg', fileSize);
                                _this.croppedCallback(attachFileName, saveName, fileSize);
                            }
                        },
                        FilesAdded : function(up, files){
                            _this.getCredentials();
                        },
                        BeforeUpload : function(up, file){
                            _this.cancelCrop();//上传之前 销毁剪裁框
                            up.disableBrowse(true);
                        },
                        Error : function(up, err) {
                            up.disableBrowse(false);
                            up.refresh(); // Reposition Flash/Silverlight
                            weui.alert(err.message);
                        }
                    }
                });
                uploader.init();
                _this.uploader = uploader;
                console.log('initUploader');
            },
            init : function(base64, fileName, fileSize, cropped, onCrop, cancelCrop){
                var _this = this;

                //base64 = "data:image/jpeg;base64," + _this.imgdata;
                //_this.croppedCallback('../../../../../static/images/test/1.jpg', '../../../../../static/images/test/1.jpg', fileSize);

                if(!_this.uploader){
                    _this.initUploader();
                }
                _this.fileName = fileName;
                _this.fileSize = fileSize;
                _this.croppedCallback = cropped;
                _this.cropCallback = onCrop;
                _this.cancelCallback = cancelCrop;

                if(_this.isCrop){//正在剪裁
                    return _this.isCrop = false;
                }
                _this.isCrop = true;
                $('#crop_area').html('<img src="' + base64 + '">');
                _this.crop  = new Cropper($('#crop_area img')[0], {
                    dragMode : 'move',
                    background : false,
                    autoCropArea : 1,
                    crop(event) {},
                    ready(){
                        _this.imgLoaded = true;
                        _this.opacity = 1;
                        if(_this.cropCallback){
                            _this.cropCallback();
                        }
                    }
                });
            }
        },
        created(){
            if (!HTMLCanvasElement.prototype.toBlob) {
                Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                    value: function (callback, type, quality) {
                        var binStr = atob( this.toDataURL(type, quality).split(',')[1] ),
                            len = binStr.length,
                            arr = new Uint8Array(len);
                        for (var i=0; i<len; i++ ) {
                            arr[i] = binStr.charCodeAt(i);
                        }
                        callback( new Blob( [arr], {type: type || 'image/png'} ) );
                    }
                });
            }
        }
	}
</script>
<style scoped>

.crop-box {
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    width: 100%;
    /* height: 100%; */
    height:100vh;
    box-sizing: border-box;
    /* padding: 1rem .5rem  2rem .5rem; */
    padding-bottom: 1.5rem;
    background-color: #000;
}

.crop-area-bg {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    box-sizing: border-box;
    padding-top: 40vh;
    text-align: center;
    color: #ccc;
    font-size: .3rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}

.crop-area {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2)
}

.crop-area img {
    max-width: 100%;
}

.crop-box .btn-box {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 1.5rem;
    width: 100%;
    font-size: 0;
    text-align: center;
    padding-top: .6rem;
    box-sizing: border-box;
}

.crop-box .btn-box span {
    width: 33%;
    line-height: .9rem;
    text-align: center;
    display: inline-block;
    font-size: .3rem;
    color: #fff;
    height: .9rem;
}

.crop-box .btn-box .btn-cancel {
    float: left;
    text-align: left;
    padding-left: .4rem;
    box-sizing: border-box;
}

.crop-box .btn-box .btn-commit {
    float: right;
    text-align: right;
    padding-right: .4rem;
    box-sizing: border-box;
}

.crop-box .btn-rotate-left {
    width: 1.2rem;
    height: .6rem;
    background-image: url("../../static/images/rotate.png");
    background-size: .32rem .3rem;
    background-position: center center;
    background-repeat: no-repeat;
    position: fixed;
    left: 0;
    bottom: .9rem;
    z-index: 9;
}

.crop-box .btn-rotate-left:active,
.crop-box .btn-box span:active {
    background-color: rgba(255, 255, 255, .3);
}

.crop-area img{
    max-width: 100%;
}

.crop-box {
    -webkit-transform:translateZ(1px);
    -moz-transform:translateZ(1px);
    -o-transform:translateZ(1px);
    transform:translateZ(1px);
}
</style>



// WEBPACK FOOTER //
// src/plugins/crop.vue